import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/components/login/Login'
import ConfirmationPassword from '@/views/components/forgotPassword/ConfirmationPassword'
import NewPasswordConfirmation from '@/views/components/forgotPassword/NewPasswordConfirmation'
import RecoveryEmail from '@/views/components/forgotPassword/RecoveryEmail'
import NewPassword from '@/views/components/forgotPassword/NewPassword'
import SelfRegistration from '@/views/components/firstAccess/SelfRegistration'
import SelfRegistrationConfirm from '@/views/components/firstAccess/SelfRegistrationConfirm'
import FirstAccess from '@/views/components/firstAccess/FirstAccess'
import NavBar from '@/common/components/NavBar'
import PrivacyPolicy from '@/common/components/accepts/PrivacyPolicy'
import Home from '@/views/components/home/Home'
import RegisteredPayerUser from '@/views/components/user/RegisteredPayerUser'
import MyUsers from '@/views/components/myUsers/MyUsers'
import CallCenter from '@/views/components/callcenter/CallCenter'
import WrongUrl from '@/common/components/WrongUrl'
import store from "../store/store"
import UrlExpired from '@/common/components/UrlExpired'
import MyProfile from "@/views/components/myprofile/MyProfile"
import CookiesPolicy from '@/common/components/accepts/CookiesPolicy'

// directory route & views

Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [{
            path: '/myProfile',
            name: 'myProfile',
            component: MyProfile,
        },

        {
            path: '/selfRegistration',
            name: 'selfRegistration',
            component: SelfRegistration,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/selfRegistrationConfirm',
            name: 'selfRegistrationConfirm',
            component: SelfRegistrationConfirm,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/MyUsers',
            name: 'MyUsers',
            component: MyUsers,

        },

        {
            path: '/firstAccess',
            name: 'FirstAccess',
            component: FirstAccess,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/urlExpired',
            name: 'UrlExpired',
            component: UrlExpired
        },

        {
            path: '/confirmationPassword',
            name: 'ConfirmationPassword',
            component: ConfirmationPassword,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/NewPasswordConfirmation',
            name: 'NewPasswordConfirmation',
            component: NewPasswordConfirmation,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/newPassword',
            name: 'NewPassword',
            component: NewPassword,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/recoveryEmail',
            name: 'RecoveryEmail',
            component: RecoveryEmail,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
        },


        {
            path: '/registeredPayerUser',
            name: 'RegisteredPayerUser',
            component: RegisteredPayerUser,

        },
        {
            path: '/callcenter',
            name: 'CallCenter',
            component: CallCenter,

        },

        {
            path: '/navBar',
            name: 'NavBar',
            component: NavBar,

        },
        {
            path: '/PrivacyPolicy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/CookiesPolicy',
            name: 'CookiesPolicy',
            component: CookiesPolicy,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/:group',
            name: 'Login',
            component: Login,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/',
            name: 'WrongUrl',
            component: WrongUrl,
            meta: {
                requiresAuth: false
            }
        },
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => (record.meta.requiresAuth !== false))) {
        if (store.getters.isLoggedIn) {
            next()
            return
        }
        next(`/${localStorage.getItem("group")}`).catch(() => {})
    } else {
        next()
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router/router.js